/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Filter_VoicesInputs */

const en_common_filter_voices = /** @type {(inputs: Common_Filter_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter voices`)
};

const es_common_filter_voices = /** @type {(inputs: Common_Filter_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar voces`)
};

/**
* | output |
* | --- |
* | "Filter voices" |
*
* @param {Common_Filter_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_filter_voices = /** @type {((inputs?: Common_Filter_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Filter_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_filter_voices(inputs)
	return en_common_filter_voices(inputs)
});